import { configureStore } from "@reduxjs/toolkit";
import ThemeReducer from "../slices/ThemeSlice";

export const ThemeStore = configureStore({
  reducer: {
    theme: ThemeReducer,
  },
});
